'use client';

import { type DateValue, parseDateTime } from '@internationalized/date';
import { I18nProvider } from '@react-aria/i18n';
import { DatePicker } from '@xefi/x-react/datepicker';
import type { InputFieldProps } from '@/models/inputFields';
type DateHourFieldProps = InputFieldProps<Date | string>;
export const DateHourField = ({
  value,
  onChange,
  readonly
}: DateHourFieldProps) => {
  const dateValue = value ? (() => {
    try {
      let isoString: string;
      if (typeof value === 'string') {
        isoString = value.replace(/Z$/, '').replace(/[+-]\d{2}:\d{2}$/, '');
      } else {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, '0');
        const day = String(value.getDate()).padStart(2, '0');
        const hours = String(value.getHours()).padStart(2, '0');
        const minutes = String(value.getMinutes()).padStart(2, '0');
        const seconds = String(value.getSeconds()).padStart(2, '0');
        isoString = `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
      }
      return parseDateTime(isoString);
    } catch (error) {
      console.error('Error parsing date:', error);
      return null;
    }
  })() : null;
  return <I18nProvider locale='fr-FR'>
         <DatePicker isReadOnly={readonly} granularity='minute' hideTimeZone value={dateValue} onChange={(value_0: DateValue | null) => {
      if (value_0) {
        const year_0 = value_0.year;
        const month_0 = String(value_0.month).padStart(2, '0');
        const day_0 = String(value_0.day).padStart(2, '0');
        const hours_0 = String('hour' in value_0 ? value_0.hour : 0).padStart(2, '0');
        const minutes_0 = String('minute' in value_0 ? value_0.minute : 0).padStart(2, '0');
        const seconds_0 = String('second' in value_0 ? value_0.second : 0).padStart(2, '0');
        const isoString_0 = `${year_0}-${month_0}-${day_0}T${hours_0}:${minutes_0}:${seconds_0}`;
        onChange?.(isoString_0);
      } else {
        onChange?.(undefined);
      }
    }} className='h-12 w-full rounded-lg' />
      </I18nProvider>;
};